import { useSelector, useDispatch } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './index';
import type { TwapPoint, VwapPoint, MicropricePoint, LastPricePoint } from './chartDataSlice';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Per-symbol selectors — only the calling component re-renders on change.

export function useTwapData(secId: string): TwapPoint[] {
  return useAppSelector(s => s.chartData.twap[secId.toUpperCase()] ?? []);
}

export function useVwapData(secId: string): VwapPoint[] {
  return useAppSelector(s => s.chartData.vwap[secId.toUpperCase()] ?? []);
}

export function useMicropriceData(secId: string): MicropricePoint[] {
  return useAppSelector(s => s.chartData.microprice[secId.toUpperCase()] ?? []);
}

export function useLastPriceData(secId: string): LastPricePoint[] {
  return useAppSelector(s => s.chartData.lastPrice[secId.toUpperCase()] ?? []);
}
